import { InfoIcon } from "lucide-react"

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

/**
 * An "i" affordance for a field whose label can't carry the whole explanation.
 *
 * A Popover rather than a Tooltip because Radix tooltips deliberately have no
 * touch support, and FundReady takes heavy mobile traffic from partner links -
 * the prospects who most need the jargon explained are the ones who could
 * never open it. This opens on click, tap, and Enter alike.
 */
export function FieldInfo({ text }: { text: string }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="More information"
          className="text-fr-muted hover:text-fr-brand shrink-0 cursor-pointer transition-colors"
        >
          <InfoIcon className="size-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="max-w-70 text-[12.5px] leading-[1.45]"
      >
        {text}
      </PopoverContent>
    </Popover>
  )
}
